export default __webpack_public_path__ + "static/media/Oro-2Closed.3c7e9b56.jpg";